module.exports = __webpack_public_path__ + "img/a4.5790df87.jpg";